import { render, staticRenderFns } from "./speech_template.vue?vue&type=template&id=0c849970&"
import script from "./speech_template.vue?vue&type=script&lang=js&"
export * from "./speech_template.vue?vue&type=script&lang=js&"
import style0 from "./speech_template.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports